<template>
  <section class="dashboard">
    <div class="page-header">
      <h3 class="page-title">

     Dashboard </h3>
    
    </div>
 

    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <!--
            <h4 class="card-title">Anfragen</h4>
            <div class="table-responsive">
              
              <table class="table">
                <thead>
                  <tr>
                    <th> Assignee </th>
                    <th> Subject </th>
                    <th> Status </th>
                    <th> Last Update </th>
                    <th> Tracking ID </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      David Grey </td>
                    <td> Fund is not recieved </td>
                    <td>
                      <label class="badge badge-gradient-success">DONE</label>
                    </td>
                    <td> Dec 5, 2017 </td>
                    <td> WD-12345 </td>
                  </tr>
                
                </tbody>
              </table>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>


  </section>
</template>

<script>




export default {
  name: 'dashboard',
  components: {


  },
  data() {
    return {
      time1: null
    };
  }
}
</script>

<style scoped>

</style>